import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import api from "../../../service/api";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Main from "../../../components/Main";
import ModalShare from "../../../components/ModalShare";
import Table from "../../../components/Table";
import Animation from "../../../components/Animation/animation";


import { THead, Th, ThFilterable, Td, DetailsButton } from "./styles";

//data
import routes from "../../../routes/orderPay.routes";

//Help Functions
import {openModal} from "../../../helpers/modalFunctions";

//Interfaces
import { PaymentOrderDataInterface } from "./interfaces";

const PaymentOrderList = () => {
    const [paymentListData, setPaymentListData] = useState<Array<PaymentOrderDataInterface>>([]);
    const [selectedPaymentOrder, setSelectedPaymentOrder] = useState<PaymentOrderDataInterface>({
        br_standardLogo: "",
        branchsId: "",
        bu_amount: "",
        bu_buyersId: "",
        bu_description: "",
        bu_id: "",
        bu_numberInstalments: 0,
        bu_payment_limit_date: "",
        bu_sellerOwnerPayId: "",
        bu_url: "",
        by_email: "",
        by_firstName: "",
        by_lastName: "",
        by_phoneNumber: "",
        by_taxpayerId: "",
        shortUrl: "",
        bu_created_at: ""
    })
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);


    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

    const [message, setMessage] = useState("");

    const login = useSelector((state: {login: any}) => state.login);

    useEffect(() => {
        const getPaymentOrderAtApi = async () => {
            const {data} = await api.get("boletos/list", {
                params: {
                    branchsId: login.user.branchsId,
                    page
                }
            });
            
            setPaymentListData(data.boletos)
            setMaxPage(data.pageCount);
            setIsLoading(false)
        }

        if(debouncedSearchTerm === ""){
            getPaymentOrderAtApi();
        }

    }, [page, debouncedSearchTerm]);

    useEffect(() => {
        setIsLoading(true)
        const timerId = setTimeout(() => {
            setPage(1);
            setDebouncedSearchTerm(searchTerm);
        }, 1200);
    
        return () => {
            clearTimeout(timerId);
        }
    }, [searchTerm]);
    
    useEffect(() => {
        const getPayOrdersFilteredAtApi = async () => {
            const {data} = await api.get("/boletos/list", {
                params: {
                    branchsId: login.user.branchsId,
                    filter: debouncedSearchTerm,
                    page
                }
            });      
            
            setPaymentListData(data.boletosFilter);
            setMaxPage(data.pageCount);
            setIsLoading(false)
        }
        
        if(debouncedSearchTerm !== ""){
            getPayOrdersFilteredAtApi();
        }
    }, [debouncedSearchTerm, page]);

    const sendEmail = async () => {
        try{
            const { data } = await api.post("/boletos/send/email", {
                id: selectedPaymentOrder.bu_id,
                email: selectedPaymentOrder.by_email,
                link: selectedPaymentOrder.shortUrl,
                buyer_name: `${selectedPaymentOrder.by_firstName} ${selectedPaymentOrder.by_lastName}`,
                establishment: login.user.branchs.businessName
            });
    
            setMessage("Email enviado com sucesso");
        } catch(error){
            setMessage("Falha ao enviar email")
        }
    }

    const sendWhatsapp = async () => {
        try {
            const {data} = await api.post("/linkpay/send/whats", {
                link: selectedPaymentOrder.shortUrl,
                phoneSms: `55${selectedPaymentOrder.by_phoneNumber}`,
                amount: selectedPaymentOrder.bu_amount,
                description: selectedPaymentOrder.bu_description,
                establishment: login.user.branchs.businessDescription
            });
    
            setMessage("Mensagem enviada com sucesso");
        } catch (error) {
            setMessage("Falha ao enviar mensagem");
        }
    }

    const paymentOrderTrGenerator = () => {
        return paymentListData.map(paymentOrder => {
            return (
                <tr style={{ height: 67 }} key={paymentOrder.bu_id}>
                    <Td>{paymentOrder.bu_id}</Td>
                    <Td>{`${paymentOrder.by_firstName} ${paymentOrder.by_lastName}`}</Td>
                    <Td>R$ {(Number(paymentOrder.bu_amount) / 100).toLocaleString("pt-br", {maximumFractionDigits: 2, minimumFractionDigits: 2})}</Td>
                    <Td>{moment(paymentOrder.bu_created_at).add(3, "hours").format("DD/MM/YYYY")}</Td>
                    <Td>{moment(paymentOrder.bu_payment_limit_date).add(3, "hours").format("DD/MM/YYYY")}</Td>
                    <Td style={{paddingTop: 9}}>
                        <DetailsButton onClick={() => handleShareButtonClick(paymentOrder)}>
                            <span>Compartilhar</span>
                        </DetailsButton>
                    </Td>
                </tr>
            )
        })
    }

    const handleShareButtonClick = async (selectedPaymentOrderParam: PaymentOrderDataInterface) => {
        // const {data} = await api.get(`/link`, {
        //     params: {
        //         link: selectedPaymentOrderParam.bu_url
        //     }
        // })
        setSelectedPaymentOrder({...selectedPaymentOrderParam, shortUrl: selectedPaymentOrderParam.bu_url});
        setMessage("");
        openModal("exampleModal");
    }

    return(
        <div className="w-100 h-100">
            <Header title="Boleto" subTitle="Gere pagamentos via boleto bancário de forma fácil e rápida." subTitleWidth={236}/>
            <NavTabs tabs={routes}/>

            <ModalShare
                text="Enviar Boleto"
                type={1}
                sendEmail={sendEmail}
                sendWhatsapp={sendWhatsapp}
                linkExternal={selectedPaymentOrder.shortUrl}
                message={message}
            />

            <Main className="column-content">
                <Table
                    page={page}
                    maximumPage={maxPage}
                    setPage={setPage}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                >
                    <THead>
                        <tr>
                            <Th>id</Th>
                            <Th>cliente</Th>
                            <Th>valor</Th>
                            <Th>emissão</Th>
                            <Th>vencimento</Th>
                            <Th></Th>
                        </tr>
                    </THead>
                    {
                        isLoading 
                        ? <Animation/>
                        : <tbody>
                            { paymentOrderTrGenerator() }
                        </tbody>
                    }
                </Table>
            </Main>
        </div>
    )
}

export default PaymentOrderList;